import { render, staticRenderFns } from "./UserAccessTable.vue?vue&type=template&id=00b60500&scoped=true&"
import script from "./UserAccessTable.vue?vue&type=script&lang=js&"
export * from "./UserAccessTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b60500",
  null
  
)

export default component.exports